import React from "react";
import { FaMagic } from "react-icons/fa";
import "./PageHeader.scss";
import UpgradeModal from "../UpgradeModal";

interface PageHeaderProps {
  title: string;
  buttonText?: string;
  buttonIcon?: React.ReactNode;
  onButtonClick?: () => void;
}

const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  buttonText = "Upgrade",
  buttonIcon = <FaMagic />,
  onButtonClick,
}) => {
  return (
    <div className="page-header-container">
      <span className="page-header-title">{title}</span>
      {buttonText && (
        <UpgradeModal
          onTriggerClick={onButtonClick}
          trigger={
            <button className="page-header-upgrade-btn">
              {buttonIcon} {buttonText}
            </button>
          }
        />
      )}
    </div>
  );
};

export default PageHeader;
